/**
 * Maps English country names (and a few aliases) to ISO 3166-1 alpha-2 codes.
 * react-country-flag / flag-icons require the 2-letter code (e.g. ES, not Spain).
 */
const COUNTRY_NAME_TO_CODE: Record<string, string> = {
  spain: 'ES',
  italy: 'IT',
  monaco: 'MC',
  france: 'FR',
  germany: 'DE',
  austria: 'AT',
  belgium: 'BE',
  netherlands: 'NL',
  holland: 'NL',
  hungary: 'HU',
  portugal: 'PT',
  'united kingdom': 'GB',
  uk: 'GB',
  britain: 'GB',
  'great britain': 'GB',
  england: 'GB',
  australia: 'AU',
  japan: 'JP',
  china: 'CN',
  singapore: 'SG',
  malaysia: 'MY',
  bahrain: 'BH',
  'saudi arabia': 'SA',
  qatar: 'QA',
  'united arab emirates': 'AE',
  uae: 'AE',
  azerbaijan: 'AZ',
  turkey: 'TR',
  russia: 'RU',
  canada: 'CA',
  mexico: 'MX',
  brazil: 'BR',
  'united states': 'US',
  usa: 'US',
  'united states of america': 'US',
};

/**
 * Normalize a circuit country value to an ISO 3166-1 alpha-2 code.
 * Already-valid 2-letter codes are uppercased; names like "Spain" become "ES".
 */
export function toCountryCode(country: string | null | undefined): string {
  if (!country) return '';
  const trimmed = country.trim();
  if (/^[A-Za-z]{2}$/.test(trimmed)) {
    return trimmed.toUpperCase();
  }
  return COUNTRY_NAME_TO_CODE[trimmed.toLowerCase()] || trimmed.toUpperCase();
}
